
import * as Yup from 'yup';

export const ValueAddSchema = Yup.object().shape({
  professionalReference: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().min(2, 'Too Short!').max(25, 'Too Long!').nullable(),
      organisation: Yup.string().min(1, 'Too Short!').max(25, 'Too Long!'),
    })
  ),
  languageProficiency: Yup.array().of(
    Yup.object().shape({
      language: Yup.string().required('This field is required'),
    })
  ),
  linkedInProfile: Yup.string().url('Linked in profile URL should be a valid URL').nullable(),
  nativeLocation: Yup.string().optional().nullable(),
});

